// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.events_events-container__YvvpD {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
}

.events_tab-button__xA5mj {
    background-color: #FFFFFF;
    color: #5D8EA4;
    width: 126px;
    height: 34px;
    font-size: 14px;
    border-radius: 5px;
    border: none;
    margin-right: 5px;
}

.events_tab-button-active__uC4e9 {
    background-color: #0095FF;
    color: #FFFFFF;
}

.events_tab-content-container__hEFAl {
    margin-top: 20px;
    width: 100%
}

.events_form-textfield__JMFDm {
    margin-bottom: 10px
}

.events_server-content__lp7y5 {
    padding: 30px;
    background-color: var(--color-content);
    color: var(--color-main-typography);

    width: 100%;
    height: 100vh;
}

.events_server-tabs-background__mLa\\+f {
    width: 100%;
    height: 100%;
    background-color: var(--color-content-sidebar);
    padding: 5px;
    border-radius: 5px;;
}

.events_server-content-info-url-container__gr-q6 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    margin-top: 20px
}

.events_server-content-info-url-container-item__Ze0Re {
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: flex-start;
    width: 183px;
}

.events_server-settings-button__r4QsJ {
    border: 1px solid #0095FF;
    color: #0095FF;
    background: none;
    width: 101px;
    height: 34px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 450
}

.events_server-settings-secondary__j3vqj {
    font-size: 10px;
    font-weight: 450;
    color: #8E99A0
}

.events_server-settings-highlighted__QsHSw {
    font-size: 12px;
    font-weight: 450;
    color: #0095FF;
    text-decoration: underline;
}

.events_servers-info-table__wag9- {
    border-collapse: collapse;
    width: 90%;
    margin-top: 10px;
}

.events_servers-info-row__cM1fb {
    border: none;
    height: 34px;
    text-align: left;
    font-size: 14px;
    font-weight: 450;
    padding: 5px;
    color: var(--color-secondary-typography);
}

.events_servers-info-row__cM1fb:nth-child(odd) {
    background-color: var(--color-content-sidebar);
}

.events_mainWrapper__QUea- {
    flex: 1 1;
    height: 100vh;
    display: flex;
    align-items: flex-start;
}

.events_rightBlock__HCgN6 {
    flex: 1 1;
    background: var(--color-content);
    height: 100vh;
    padding: 30px;
    color: var(--color-main-typography)
}

.events_search-controls-container__3Oq3E {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 0;
}

.events_search-field-container__a0LLX {
    display: flex;
    flex: 16 1;
}

.events_search-filter-container__DO9Nx {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 3 1;
}

.events_content-heading__Uv14g {
    margin-bottom: 40px;
    font-weight: 700;
    font-size: 20px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
}

.events_choose-date-button__Y\\+lRH {
    border-radius: 5px;
    border: none;
    background-color: var(--color-content-sidebar);
    color: var(--color-secondary-typography);
    outline: none;
    padding: 5px 10px;
    font-size: 14px;
    font-weight: 450;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: 5px;
}

.events_notification-container__FrUzA {
    overflow-y: auto;
    max-height: 95vh
}

.events_notification-container__FrUzA::-webkit-scrollbar {
    display: none;
}

.events_choose-date-button__Y\\+lRH:focus {
    outline: none;
}

.events_content-container__Rj2XO {
    padding: 0;
}

@media screen and (max-width: 1000px) {
    .events_server-content-info-url-container__gr-q6 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 5px;
        margin-top: 20px
    }

    .events_mainWrapper__QUea- {
        width: 100%;
    }

    .events_rightBlock__HCgN6 {
        background: var(--color-content);
        height: 100vh;
        padding: 30px;
        width: 100%;
        padding: 0;
    }
    .events_content-container__Rj2XO {
        padding: 30px;
    }

    .events_content-heading-container__WIqpd {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/events/events.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,mCAAmC;;IAEnC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,8CAA8C;IAC9C,wCAAwC;IACxC,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,2BAA2B;QAC3B,QAAQ;QACR;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gCAAgC;QAChC,aAAa;QACb,aAAa;QACb,WAAW;QACX,UAAU;IACd;IACA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;IAClC;AACJ","sourcesContent":[".events-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 20px;\n}\n\n.tab-button {\n    background-color: #FFFFFF;\n    color: #5D8EA4;\n    width: 126px;\n    height: 34px;\n    font-size: 14px;\n    border-radius: 5px;\n    border: none;\n    margin-right: 5px;\n}\n\n.tab-button-active {\n    background-color: #0095FF;\n    color: #FFFFFF;\n}\n\n.tab-content-container {\n    margin-top: 20px;\n    width: 100%\n}\n\n.form-textfield {\n    margin-bottom: 10px\n}\n\n.server-content {\n    padding: 30px;\n    background-color: var(--color-content);\n    color: var(--color-main-typography);\n\n    width: 100%;\n    height: 100vh;\n}\n\n.server-tabs-background {\n    width: 100%;\n    height: 100%;\n    background-color: var(--color-content-sidebar);\n    padding: 5px;\n    border-radius: 5px;;\n}\n\n.server-content-info-url-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 5px;\n    margin-top: 20px\n}\n\n.server-content-info-url-container-item {\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    justify-content: flex-start;\n    width: 183px;\n}\n\n.server-settings-button {\n    border: 1px solid #0095FF;\n    color: #0095FF;\n    background: none;\n    width: 101px;\n    height: 34px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 450\n}\n\n.server-settings-secondary {\n    font-size: 10px;\n    font-weight: 450;\n    color: #8E99A0\n}\n\n.server-settings-highlighted {\n    font-size: 12px;\n    font-weight: 450;\n    color: #0095FF;\n    text-decoration: underline;\n}\n\n.servers-info-table {\n    border-collapse: collapse;\n    width: 90%;\n    margin-top: 10px;\n}\n\n.servers-info-row {\n    border: none;\n    height: 34px;\n    text-align: left;\n    font-size: 14px;\n    font-weight: 450;\n    padding: 5px;\n    color: var(--color-secondary-typography);\n}\n\n.servers-info-row:nth-child(odd) {\n    background-color: var(--color-content-sidebar);\n}\n\n.mainWrapper {\n    flex: 1;\n    height: 100vh;\n    display: flex;\n    align-items: flex-start;\n}\n\n.rightBlock {\n    flex: 1;\n    background: var(--color-content);\n    height: 100vh;\n    padding: 30px;\n    color: var(--color-main-typography)\n}\n\n.search-controls-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    padding: 0;\n}\n\n.search-field-container {\n    display: flex;\n    flex: 16;\n}\n\n.search-filter-container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex: 3;\n}\n\n.content-heading {\n    margin-bottom: 40px;\n    font-weight: 700;\n    font-size: 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.choose-date-button {\n    border-radius: 5px;\n    border: none;\n    background-color: var(--color-content-sidebar);\n    color: var(--color-secondary-typography);\n    outline: none;\n    padding: 5px 10px;\n    font-size: 14px;\n    font-weight: 450;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n    gap: 5px;\n}\n\n.notification-container {\n    overflow-y: auto;\n    max-height: 95vh\n}\n\n.notification-container::-webkit-scrollbar {\n    display: none;\n}\n\n.choose-date-button:focus {\n    outline: none;\n}\n\n.content-container {\n    padding: 0;\n}\n\n@media screen and (max-width: 1000px) {\n    .server-content-info-url-container {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-start;\n        gap: 5px;\n        margin-top: 20px\n    }\n\n    .mainWrapper {\n        width: 100%;\n    }\n\n    .rightBlock {\n        background: var(--color-content);\n        height: 100vh;\n        padding: 30px;\n        width: 100%;\n        padding: 0;\n    }\n    .content-container {\n        padding: 30px;\n    }\n\n    .content-heading-container {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"events-container": `events_events-container__YvvpD`,
	"tab-button": `events_tab-button__xA5mj`,
	"tab-button-active": `events_tab-button-active__uC4e9`,
	"tab-content-container": `events_tab-content-container__hEFAl`,
	"form-textfield": `events_form-textfield__JMFDm`,
	"server-content": `events_server-content__lp7y5`,
	"server-tabs-background": `events_server-tabs-background__mLa+f`,
	"server-content-info-url-container": `events_server-content-info-url-container__gr-q6`,
	"server-content-info-url-container-item": `events_server-content-info-url-container-item__Ze0Re`,
	"server-settings-button": `events_server-settings-button__r4QsJ`,
	"server-settings-secondary": `events_server-settings-secondary__j3vqj`,
	"server-settings-highlighted": `events_server-settings-highlighted__QsHSw`,
	"servers-info-table": `events_servers-info-table__wag9-`,
	"servers-info-row": `events_servers-info-row__cM1fb`,
	"mainWrapper": `events_mainWrapper__QUea-`,
	"rightBlock": `events_rightBlock__HCgN6`,
	"search-controls-container": `events_search-controls-container__3Oq3E`,
	"search-field-container": `events_search-field-container__a0LLX`,
	"search-filter-container": `events_search-filter-container__DO9Nx`,
	"content-heading": `events_content-heading__Uv14g`,
	"choose-date-button": `events_choose-date-button__Y+lRH`,
	"notification-container": `events_notification-container__FrUzA`,
	"content-container": `events_content-container__Rj2XO`,
	"content-heading-container": `events_content-heading-container__WIqpd`
};
export default ___CSS_LOADER_EXPORT___;
